module.exports = __webpack_public_path__ + "static/img/Patrick_Dangerfield_mobile.f7a6025.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patrick_Dangerfield_mobile.jpg
// module id = 35Zc
// module chunks = 0